import wpo from '@ali/retcodelog/src/log-browser';
import cookieInfo from '@alife/alpha-cookie-info/cookie-info';

function initWpo() {
  // retcode设置
  wpo.setConfig(
    Object.assign(
      {
        sample: 10,
        nick: cookieInfo.getMemberId(),
      },
      (window.__WPO || {}).config,
    ),
  );

  // 打点功能不正常时报错
  if (!window.goldlog || !window.dmtrack) {
    wpo.error('aplusError', 'cannot find global goldlog or dmtrack');
  }
}

export default initWpo;
